import {
  Box,
  Container,
  Grid,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { StyledLightGreenButton } from "@Styled/Common";
import MainHeading from "@Components/Basic/MainHeading";
import Loader from "../../Loader";
import Paper from "@mui/material/Paper";
import {
  myCartMobileSkeleton,
  myCartSkeleton,
} from "@Components/Loader/Skeleton";
import router from "next/router";
import { useEffect } from "react";
import { CartActions } from "@Redux-Store/Actions";
import Header2 from "@Components/Layout/Header-2.tsx";
import dynamic from "next/dynamic";

const ProductTable = dynamic(() => import("./ProductTable"));
const TotalTable = dynamic(() => import("./TotalTable"));

export default function MyCart() {
  const theme = useTheme();
  const xsToSm = useMediaQuery(theme.breakpoints.between("xs", "sm"));
  const cartData = useSelector((state) => state?.CartReducer?.cart);
  const loader = useSelector((state) => state.CartReducer.isCartEmpty);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(CartActions.GetMyCart());
  }, []);

  return (
    <div>
      <Header2 />
      <Box
        sx={{ paddingTop: { md: "7rem", xs: "5rem" }, paddingBottom: "3rem" }}
      >
        <MainHeading
          heading="Shopping Cart"
          width="13rem"
          mobileWidth="11rem"
        ></MainHeading>

        {loader ? (
          <Loader
            renderSkeleton={xsToSm ? myCartMobileSkeleton : myCartSkeleton}
          />
        ) : (
          <>
            {cartData && cartData.cartItems?.length > 0 ? (
              <Box sx={{ marginTop: { sm: "2rem", xs: "0rem" } }}>
                {" "}
                <ProductTable cartData={cartData} />
                <TotalTable cartData={cartData} />
              </Box>
            ) : (
              <Container
                sx={{
                  alignSelf: "center",
                }}
              >
                <Grid
                  item
                  xs={12}
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center",
                  }}
                  component={Paper}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      padding: "3rem 0rem",
                    }}
                  >
                    <Typography variant="subtitle1">
                      No items in your cart
                    </Typography>
                    <StyledLightGreenButton
                      sx={{ marginTop: "1rem" }}
                      onClick={() => {
                        router.push("/");
                      }}
                    >
                      Continue shopping
                    </StyledLightGreenButton>
                  </Box>
                </Grid>
              </Container>
            )}
          </>
        )}
      </Box>
    </div>
  );
}
